// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Zbge","title":"InfoRow_title__zU-qu"};